import { createInertiaApp } from '@inertiajs/react';
import { createRoot } from 'react-dom/client';

const pages = import.meta.glob('../pages/**/*.tsx');

async function resolvePage(name: string) {
  const page = pages[`../pages/${name}.tsx`];
  if (!page) {
    throw new Error(`Page not found: ${name}`);
  }

  return await page();
}

createInertiaApp({
  resolve: resolvePage,
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />);
  },
});
